import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import { getHistoryPriceTrendForStone } from '@/service/sale/salePrice';
export default function useAggregateHistoryPriceForStone(params) {
  var aggregatePriceTrend = ref([]);
  var getPriceTrendAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getHistoryPriceTrendForStone(params.value);
          case 2:
            data = _context.sent;
            aggregatePriceTrend.value = data.list.map(function (item) {
              item.update_time = dayjs(item.update_time).format('YYYY/MM/DD');
              return item;
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getPriceTrendAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [aggregatePriceTrend, getPriceTrendAsync];
}